import './style.css'
import { ethers } from 'ethers'
import Web3Modal from "web3modal"

// import NFT from "../../contracts/NFT.json"
// import Market from "../../contracts/NFTMarket.json"
import {listForSale} from "./functions/listForSale";
import {buyNft} from "./functions/buyNFT";
import {approveMarketplaceAsManager} from "./functions/approveMarketplaceAsManager";
import {mintNFT} from "./functions/mintNFT";
import switchNetwork from "./functions/switchNetwork";
import deployContract from "./functions/deployContract";
import {fetchJson} from "ethers/lib/utils";
import Swal from "sweetalert2";
import 'sweetalert2/dist/sweetalert2.css'
import {relistForSale} from "./functions/relistForSaleButton";
import isLoggedIn from "./functions/isLoggedIn";
import forceSwitch from "./functions/forceSwitch";
import checkNetwork from "./functions/checkNetwork";

// @ts-ignore
const { __, _x, _n, _nx } = wp.i18n;


// // Dev Only
// const web3Modal = new Web3Modal()
// const connection = await web3Modal.connect()
// const provider = new ethers.providers.Web3Provider(connection)
// const signer = provider.getSigner()
let WpJsonUrl;
let homeurl = location.href;

// get JSON url
if(location.href.includes("wp-admin")) {
    WpJsonUrl = location.href;
    homeurl = WpJsonUrl.split('/wp-admin/')[0];
} else {
    // @ts-ignore
    WpJsonUrl = document.querySelector('link[rel="https://api.w.org/"]').href;
    // @ts-ignore
    homeurl = WpJsonUrl.replace('/wp-json/', '');
}
//
// const contractNFT = new ethers.Contract("0xe7f1725E7734CE288F8367e1Bb143E90bb3F0512", NFT.abi, signer);
// console.log(contractNFT);
//
// const market = new ethers.Contract("0x5FbDB2315678afecb367f032d93F642f64180aa3", Market.abi, signer);
// console.log(market);

const listForSaleButton  = document.getElementById("nft-marketplace-core-list-nft-form") as HTMLFormElement;
if(listForSaleButton !== null) {
    listForSaleButton.onsubmit = function(e){
        e.preventDefault();
        if(isLoggedIn()) {
            const elemt = document.getElementById('nft_marketplace_core_nft_listing_currency_price') as HTMLInputElement;
            if (listForSaleButton.dataset.address !== undefined && elemt !== null && listForSaleButton.dataset.marketAddress !== undefined && listForSaleButton.dataset.tokenid !== undefined) {
                listForSale(listForSaleButton.dataset.address, elemt.value, listForSaleButton.dataset.marketAddress, listForSaleButton.dataset.tokenid).then(() => {
                    Swal.fire(
                        _x('NFT Listed for sale!', 'nft-marketplace-core'),
                        _x('', 'nft-marketplace-core'),
                        'success'
                    ).then(() => listForSaleButton.submit())
                }).catch((response) => {
                    Swal.fire(
                        response.message,
                        '',
                        'error'
                    )
                });
            }
        }

        return false;
    }
}

const relistForSaleButton  = document.getElementById("nft-marketplace-core-relist-nft-form") as HTMLFormElement;
if(relistForSaleButton !== null) {
    relistForSaleButton.onsubmit = function(e) {
        e.preventDefault();
        if(isLoggedIn()) {
            const elemt = document.getElementById('nft_marketplace_core_nft_listing_currency_price') as HTMLInputElement;
            if (relistForSaleButton.dataset.address !== undefined && elemt !== null && relistForSaleButton.dataset.marketAddress !== undefined && relistForSaleButton.dataset.tokenid !== undefined) {
                relistForSale(relistForSaleButton.dataset.address, elemt.value, relistForSaleButton.dataset.marketAddress, relistForSaleButton.dataset.tokenid).then(() => {
                    Swal.fire(
                        _x('NFT Relisted', 'nft-marketplace-core'),
                        '',
                        'success'
                    ).then(() => relistForSaleButton.submit())
                }).catch((response) => {
                    Swal.fire(
                        response.message,
                        '',
                        'error'
                    )
                });
            }
        }
        return false;
    }
}


const approve  = document.getElementById("approve-nft-marketplace");

if(approve !== null) {
    approve.onclick = function (e) {
        e.preventDefault();
        if(isLoggedIn()) {

            if (approve.dataset.address !== undefined && approve.dataset.marketAddress !== undefined && approve.dataset.tokenid !== undefined) {
                approveMarketplaceAsManager(approve.dataset.address, approve.dataset.marketAddress, approve.dataset.tokenid).then(() => {
                    Swal.fire(
                        _x('Marketplace approved to manage your NFT', 'nft-marketplace-core'),
                        '',
                        'success'
                    ).then(() => location.reload())
                }).catch((response) => {
                    Swal.fire(
                        response.message,
                        '',
                        'error'
                    )
                });
            }
        }

        return false;
    }
}
const buyButtonF = (buyButton: HTMLFormElement) => {
    if (buyButton.dataset.address !== undefined && buyButton.dataset.marketplaceAddress !== undefined && buyButton.dataset.price !== undefined && buyButton.dataset.tokenid !== undefined) {
        buyNft(buyButton.dataset.address, parseFloat(buyButton.dataset.price), buyButton.dataset.marketplaceAddress, buyButton.dataset.tokenid).then((data) => {
            Swal.fire(
                _x('NFT Purchased!', 'nft-marketplace-core'),
                _x('It\'s going to appear inside your wallet soon', 'nft-marketplace-core'),
                'success'
            ).then(() =>{
                console.log(data);

                const x = document.createElement("INPUT");
                x.setAttribute("type", "text");
                x.setAttribute("value", JSON.stringify(data))
                x.setAttribute("hidden", "true")
                x.setAttribute("name", "nft_marketplace_core_buy_data")
                buyButton.appendChild(x);
                buyButton.submit();
            })
        }).catch((response) => {
            Swal.fire(
                response.message,
                '',
                'error'
            )
        });
    }
}
const buyButton  = document.getElementById("nft-marketplace-core-buy-nft-form") as HTMLFormElement;
if(buyButton !== null) {
    buyButton.onsubmit = function (e) {
        e.preventDefault();
        if(isLoggedIn()) {
            if(buyButton.dataset.forceSwitchTo !== undefined) {
                const dataset = JSON.parse(buyButton.dataset.forceSwitchTo);
                checkNetwork(dataset.nft_marketplace_core_taxonomy_blockchain_currency_chainid[0]).then((result) => {
                    result ? buyButtonF(buyButton) : forceSwitch(dataset, buyButton);
                })
            } else {
                buyButtonF(buyButton);
            }
        }
        return false;
    }
}

const mintButton  = document.getElementById("nft-marketplace-core-mint-nft-form") as HTMLFormElement;
if(mintButton !== null) {
    mintButton.onsubmit = function (e) {
        e.preventDefault();
        if(isLoggedIn()) {
            if (mintButton.dataset.address !== undefined) {
                console.log(mintButton.dataset.address)

                mintNFT(mintButton.dataset.address).then(() => {
                    Swal.fire(
                        _x('NFT Minted!', 'nft-marketplace-core'),
                        _x('It\'s going to appear inside your wallet soon', 'nft-marketplace-core'),
                        'success'
                    ).then(() => mintButton.submit())
                }).catch((response) => {
                    Swal.fire(
                        response.message,
                        '',
                        'error'
                    )
                });
            }
        }

        return false;
    }
}

const changeBlockchain  = document.getElementById("nft-change-blockchain") as HTMLSelectElement;
if(changeBlockchain !== null) {
    changeBlockchain.onchange = function () {
        const currentOption = changeBlockchain.options[changeBlockchain.selectedIndex];
        const rawData = currentOption.dataset.blockchain;
        if (rawData !== undefined) {
            const dataset = JSON.parse(rawData);
            switchNetwork(dataset,currentOption.text);
        }
    }
}

const deployForm  = document.getElementById("nft-marketplace-core-form-to-deploy") as HTMLFormElement;
if(deployForm !== null) {
    deployForm.onsubmit = function (e) {
        e.preventDefault();
        const json = fetchJson(homeurl + "/wp-content/plugins/nft-marketplace-core/contracts/NFTMarket.json");
        json.then((data) => {
            const formData = new FormData(deployForm);
            const values: FormDataEntryValue[] = [];
            formData.forEach((s,d) => {
                const curElement = deployForm.querySelectorAll(`[name="${d}"]`)[0] as HTMLElement;
                if(curElement.dataset.ignore !== "true") {
                    // @ts-ignore
                    if(s < 1) {
                        // @ts-ignore
                        values.push(ethers.utils.parseEther(s));
                    } else {
                        values.push(s);
                    }
                }
            })

            deployContract(data, values).then((data) => {
                const resultField = deployForm.querySelectorAll(`[name="nft_listing_result"]`)[0] as HTMLInputElement;
                resultField.value = data.address;
                Swal.fire(
                    _x( 'Contract Deployed successfully!', 'nft-marketplace-core' ) ,
                    "",
                    'success'
                ).then(() => {
                    deployForm.submit()
                })
            }).catch((response) => {
                Swal.fire(
                    response.message ,
                    "",
                    'error'
                )
            });
        })
        return false;
    }
}


const callSetterForm  = document.getElementById("nft-marketplace-core-call-setter") as HTMLFormElement;
if(callSetterForm !== null) {
    callSetterForm.onsubmit = function (e) {
        e.preventDefault();
        if (callSetterForm.dataset.contractAddress !== undefined) {

            const json = fetchJson(homeurl + "/wp-content/plugins/nft-marketplace-core/contracts/NFTMarket.json");
            json.then(async (data) => {
                const formData = new FormData(callSetterForm);
                const values: any[] = [];

                const web3Modal = new Web3Modal()
                const connection = await web3Modal.connect()
                const provider = new ethers.providers.Web3Provider(connection)
                const signer = provider.getSigner()
                //@ts-ignore
                const contract = new ethers.Contract(callSetterForm.dataset.contractAddress, data.abi, signer)
                var decimalPlaces = 18;

                formData.forEach((s, d) => {

                    const curElement = callSetterForm.querySelectorAll(`[name="${d}"]`)[0] as HTMLElement;

                    if (curElement.dataset.ignore !== "true") {
                        if (curElement.dataset.isBigNumber === "true") {
                            console.log(ethers.utils.parseUnits(s.toString(), decimalPlaces))
                            values.push(ethers.utils.parseUnits(s.toString(), decimalPlaces));
                        } else {
                            values.push(s);
                        }
                    }
                })

                //@ts-ignore function exists
                await contract[callSetterForm.dataset.functionName](...values).then(() => {
                    Swal.fire(
                        _x('Contract Updated successfully!', 'nft-marketplace-core'),
                        "",
                        'success'
                    ).then(() => {
                        deployForm.submit()
                    })
                }).catch((response: any) => {
                    Swal.fire(
                        response.message,
                        "",
                        'error'
                    )
                });
            })
        }

        return false;
    }
}

